import type { Product } from '../../../data/product';
import { preciseCurrencyFormatter } from '../../../helpers/format-currency';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const FutureCost: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Future Cost',
  minWidth: 70,
  accessorFn: (product) => {
    if (product.pricing.future_cost) {
      return preciseCurrencyFormatter(product.pricing.future_cost);
    }

    return '';
  },
  toCSV: (product) => ({
    'Future Cost': product.pricing.future_cost ? product.pricing.future_cost.toFixed(2) : '',
  }),
});
